import { createGlobalStyle } from 'styled-components';
import { colors, font, media, sizes } from 'styles/variables';

const GlobalStyle = createGlobalStyle`
  // http://meyerweb.com/eric/tools/css/reset/ 
  // v2.0 | 20110126
  // License: none (public domain)
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font: inherit;
      vertical-align: baseline;
  }
  // HTML5 display-role reset for older browsers
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
      display: block;
  }
  body {
      line-height: 1;
  }
  ol, ul {
      list-style: none;
  }
  blockquote, q {
      quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
      content: '';
      content: none;
  }
  table {
      border-collapse: collapse;
      border-spacing: 0;
  }

  // custom globals
  .--hidden {
    display:none !important;
  }
  hr {
    border: 0;
    border-top: 1px solid hsla(0, 0%, 50%, 0.2);
    margin:0;
  }
  * {
    box-sizing: border-box;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  body {
    font-family: ${font.body};
    font-size: ${font.size};
    background: ${colors.background[0]};
    color: ${colors.foreground[0]};
  }
  h1,h2,h3,h4,h5,h6,p,small,strong,.em,a {
		display:inline-block;
    color:${colors.foreground[0]};
  }
  input,textarea {
		font-size:0.9rem;
		font-weight:400;
    line-height:175%;
    color:${colors.foreground[0]};
    font-family: ${font.body};
  }
  h1,.--h1 {
    font-family: ${font.head};
		font-weight:900;
    line-height:125%;
    margin-bottom:${sizes[1]};
    text-transform:capitalize;
    ${media.notsmall}{
		  font-size:3.25rem;
    }
    ${media.small}{
		  font-size:2rem;
    }
  }
  h2,.--h2{
    font-family: ${font.head};
		font-size:2rem;
		font-weight:700;
    line-height:125%;
    text-transform:capitalize;
  }
  h3,.--h3{
    font-family: ${font.head};
		font-size:1.1rem;
		font-weight:700;
    line-height:150%;
    text-transform:uppercase;
    margin-bottom:${sizes[0]};
    text-transform:capitalize;
  }
	p,.--p, li {
		font-weight:400;
    line-height:175%;
    ${media.notsmall}{
		font-size:1rem;
    }
    ${media.small}{
		font-size:0.8rem;
    }
  }
	strong, .em {
		font-size:1rem;
		font-weight:700;
    line-height:150%;
  }
	small{
		font-size:0.8rem;
		font-weight:400;
    line-height:175%;
    color:${colors.foreground[2]};
  }
  span {
    color:${colors.brand.base};
  }
  a {
    color:inherit;
    text-decoration:none;
  }

  // animations
  @keyframes rotate {
    from {
      transform: rotate(45deg);
    }
    to {
      transform: rotate(405deg);
    }
  }

  // media
  ${media.small} {
    .--notsmall,
    .--medium,
    .--large {
      display: none !important;
    }
  }
  ${media.medium} {
    .--small,
    .--notmedium,
    .--large {
      display: none !important;
    }
  }
  ${media.large} {
    .--small,
    .--medium,
    .--notlarge {
      display: none !important;
    }
  }
}
`;
export default GlobalStyle;
